<template>
  <b-list-group v-if="users.length > 0">
    <b-row>
      <b-col
        v-for="user in users" :key="user.userId" cols="6">
        <b-list-group-item :class="borderClassByRole(user)">
          <b-row>
            <b-col cols="auto">
              <b-form-checkbox v-model="user.selected"></b-form-checkbox>
            </b-col>
            <b-col>
              {{user.name}}
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-col>
    </b-row>
  </b-list-group>
</template>

<script>
export default {
  name: "SelectUsersList",
  props: {
    users: { type: Array, default: () => [] }
  },
  methods: {
    borderClassByRole(invitee) {
      if (invitee.role === "Owner") {
        return "border-owner";
      }

      if (invitee.role === "Contractor") {
        return "border-contractor";
      }

      return "";
    }
  }
}
</script>

<style scoped>
.border-owner {
  border-left-width: 6px;
  border-left-color: #4a708b;
}
.border-contractor {
  border-left-width: 6px;
  border-left-color: #34bf1b;
}
</style>